export const QUESTION_LIST_REQUEST = "QUESTION_LIST_REQUEST";
export const QUESTION_LIST_RECEIVE = "QUESTION_LIST_RECEIVE";
export const QUESTION_LIST_FAILURE = "QUESTION_LIST_FAILURE";
export const RESET_QUESTION_LIST = "RESET_QUESTION_LIST";


export const OPTIONS_FETCH_REQUEST = "OPTIONS_FETCH_REQUEST";
export const OPTIONS_FETCH_RECEIVE = "OPTIONS_FETCH_RECEIVE";
export const OPTIONS_FETCH_FAILURE = "OPTIONS_FETCH_FAILURE";
export const RESET_OPTIONS_FETCH = "RESET_OPTIONS_FETCH";